import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header d-flex flex-row justify-content-between" }
const _hoisted_3 = { class: "d-flex flex-column col-9 justify-content-center" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "col d-flex flex-column align-items-end justify-content-center" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: "fw-medium text-gray-800 fs-1 lh-base",
          innerHTML: _ctx.$sanitize(_ctx.title)
        }, null, 8, _hoisted_4),
        _createElementVNode("span", {
          class: "fw-medium text-gray-500 fs-5",
          innerHTML: _ctx.$sanitize(_ctx.subtitle)
        }, null, 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "actions")
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_DataTable, _mergeProps({
        data: _ctx.dataTableRows,
        header: _ctx.dataTableHeaders
      }, _ctx.$attrs, {
        onOnSort: _ctx.onSort,
        class: "table table-row-dashed"
      }), _createSlots({ _: 2 }, [
        _renderList(_ctx.dataTableHeaders, (_, index) => {
          return {
            name: index,
            fn: _withCtx(({ row: data }) => [
              _createElementVNode("span", {
                innerHTML: _ctx.$sanitize(data[index])
              }, null, 8, _hoisted_8)
            ])
          }
        })
      ]), 1040, ["data", "header", "onOnSort"])
    ])
  ]))
}